import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/localization/i18n";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import "leaflet/dist/leaflet.css";

Vue.config.productionTip = false;
axios.defaults.baseURL = "https://archive.api.eomap.com";
// axios.defaults.baseURL = "http://127.0.0.1:8000";

import Keycloak from "keycloak-js";
import tokenInterceptor from "@/services/interceptors";

const keycloak = new Keycloak({
  url: process.env.VUE_APP_KC_URL,
  realm: "eomap",
  clientId: "eoarchive",
});

keycloak
  .init({
    onLoad: "login-required",
    checkLoginIframe: false, // optional: disables iframe login check
    pkceMethod: "S256", // recommended for security
    redirectUri: window.location.origin,
  })
  .then((authenticated) => {
    Vue.prototype.$keycloak = keycloak;
    if (authenticated) {
      // Make Keycloak available globally
      tokenInterceptor();
      // Start Vue app
      new Vue({
        router,
        store,
        vuetify,
        i18n,
        render: (h) => h(App),
      }).$mount("#app");
    } else {
      console.warn("Not authenticated");
      keycloak.login();
    }
  })
  .catch((error) => {
    console.error("Keycloak init error:", error);
  });
